import { ROUTE_PATH as MERCHANTS_PAGE_PATH } from '@/features/merchantsPage/consts';

export const ROUTE_PATH = `${MERCHANTS_PAGE_PATH}/new`;

export const FEATURE_NAME = 'merchantCreatePage';
